// extracted by mini-css-extract-plugin
module.exports = {"nameContainerProduct":"styles_nameContainerProduct__bFpeX","nameProductLabel":"styles_nameProductLabel__2t7aV","nameInputProduct":"styles_nameInputProduct__1-QUK"};